import styled, { createGlobalStyle } from 'styled-components'

export const GeographyMultiSelectMenuFix = createGlobalStyle`
  .mds__menu .mds__option .mds-input {
    pointer-events: none;
  }
`

const Wrapper = styled.div`
  margin: 8px 16px 16px 0;

  .geography-range-row {
    align-items: flex-end;
    display: flex;
    flex-wrap: nowrap;
    gap: 12px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  .geography-range-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex: 1 1 0;
    min-width: 0;
    max-width: calc(50% - 6px);
    box-sizing: border-box;

    label {
      font-size: 16px;
      color: rgb(77, 77, 77);
      font-weight: 500;
      text-align: left;
      align-self: stretch;
      display: block;
    }

    .mds__value-container {
      flex-wrap: nowrap;
      overflow: hidden;
    }

    .geography-collapsed-multi-value {
      display: block;
      flex: 1;
      min-width: 0;
      max-width: 100%;
      overflow: hidden;
    }

    .geography-collapsed-multi-value__text {
      color: #333333;
      display: block;
      font-size: 14px;
      line-height: 1.35;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`

export default Wrapper
